function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.25 12.6875V7.43754C12.25 6.71293 11.6621 6.12504 10.9375 6.12504H10.5V4.41606C10.5 1.99888 8.55584 0.00825921 6.13866 5.60949e-05C3.71874 -0.00814701 1.75 1.95787 1.75 4.37505V6.12504H1.3125C0.58789 6.12504 0 6.71293 0 7.43754V12.6875C0 13.4121 0.58789 14 1.3125 14H10.9375C11.6621 14 12.25 13.4121 12.25 12.6875ZM5.57811 10.9375C5.57811 11.2383 5.8242 11.4844 6.12498 11.4844C6.42576 11.4844 6.67186 11.2383 6.67186 10.9375V9.18753C6.67186 8.88675 6.42576 8.64065 6.12498 8.64065C5.8242 8.64065 5.57811 8.88675 5.57811 9.18753V10.9375ZM9.62497 6.12503V4.37504C9.62497 2.44457 8.05545 0.875042 6.12498 0.875042C4.19452 0.875042 2.62499 2.44457 2.62499 4.37504V6.12503H9.62497ZM11.375 7.43753V12.6875C11.375 12.9281 11.1781 13.125 10.9375 13.125H1.31249C1.07186 13.125 0.874989 12.9281 0.874989 12.6875V7.43753C0.874989 7.19691 1.07186 7.00003 1.31249 7.00003H10.9375C11.1781 7.00003 11.375 7.19691 11.375 7.43753Z",
  fill: "current"
});

function SvgLockV2(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockV2);
export default __webpack_public_path__ + "static/media/lock_v2.33e210a4.svg";
export { ForwardRef as ReactComponent };